import React, { useContext } from "react"
import styled, { ThemeContext, css } from "styled-components"
import Icon from "./icon"
import { OutboundLink } from "gatsby-plugin-google-gtag"

const ButtonStyles = css`
    background: ${({ props }) =>
        props.invert
            ? props => props.theme.background
            : props => props.theme.primary};
    color: ${({ props }) =>
        props.invert
            ? props => props.theme.primary
            : props => props.theme.background};
    padding: 8px 1.25rem;
    text-decoration: none;
    display: ${props => (props.desktop ? "none" : "inline-block")};
    margin-top: 1rem;
    margin-right: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    border-radius: 2px;
    box-sizing: border-box;
    position: ${({ props }) => (props.absolute ? "absolute" : "static")};
    z-index: 1000;
    transition: 0;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
    border: ${({ props }) =>
        props.invert
            ? props => "2px solid " + props.theme.background
            : props => "2px solid " + props.theme.primary};
    &:hover {
        background: ${({ props }) =>
            props.invert && !props.animated
                ? props => props.theme.primary
                : props => props.theme.background};
        color: ${({ props }) =>
            props.invert && !props.animated
                ? props => props.theme.background
                : props => props.theme.primary};
        border: ${({ props }) =>
            props.invert && !props.animated
                ? props => "2px solid " + props.theme.background
                : !props.animated
                ? props => "2px solid " + props.theme.primary
                : props => "2px solid " + props.theme.background};
    }
    @media screen and (min-width: 768px) {
        display: inline-block;
    }
`

const StyledButton = styled.a`
    ${ButtonStyles}
`

const StyledOutboundLink = styled(OutboundLink)`
    ${ButtonStyles}
`

const TextButton = styled(StyledOutboundLink)`
    border-color: ${props => props.theme.text};
    color: ${props => props.theme.text};
    background: ${props => props.theme.background};
    cursor: pointer;
    &:hover {
        border-color: ${props => props.theme.darkGrey};
        color: ${props => props.theme.background};
        background: ${props => props.theme.darkGrey};
    }
`

const HeaderButton = styled(StyledOutboundLink)`
    transition: all 0.2s;
    border-color: ${props => props.theme.grey};
    color: ${props => props.theme.primary};
    background: ${props => props.theme.background};
    cursor: pointer;
    &:hover {
        border-color: ${props => props.theme.darkGrey};
    }
`

const AnimatedButton = styled(StyledButton)`
    background: white;
    border: 2px solid #7b7b7b;

    &:hover {
        background: white;
        border: white;
    }
`

export default function Button(props) {
    const themeContext = useContext(ThemeContext)
    if (props.animated) {
        return (
            <AnimatedButton
                props={props}
                style={props.style}
                href={props.to || "about:blank"}
                target="_blank"
            >
                {props.children}
                <Icon
                    style={{
                        position: "absolute",
                        right: "8px",
                        color: themeContext.primary,
                        top: "0",
                    }}
                >
                    east
                </Icon>
            </AnimatedButton>
        )
    } else if (props.text) {
        return (
            <TextButton
                props={props}
                onClick={props.onClick || null}
                style={props.style}
                href={props.to || null}
                target={props.target || null}
            >
                {props.children}
            </TextButton>
        )
    } else if (props.header) {
        return (
            <HeaderButton
                props={props}
                onClick={props.onClick || null}
                style={props.style}
                href={props.to || null}
                target={props.target || null}
            >
                {props.children}
            </HeaderButton>
        )
    } else if (props.outbound) {
        return (
            <StyledOutboundLink
                props={props}
                onClick={props.onClick || null}
                style={props.style}
                href={props.to || null}
                target={props.target || null}
            >
                {props.children}
            </StyledOutboundLink>
        )
    } else {
        return (
            <StyledButton
                props={props}
                onClick={props.onClick || null}
                style={props.style}
                href={props.to || null}
                target={props.target || null}
            >
                {props.children}
            </StyledButton>
        )
    }
}
